import { type InFlightView, inFlightCard } from "../src/in-flight-view.ts";

/**
 * What the Work panel says while the app is writing a draft, or after it stopped without one
 * (docs/2026-10-05-in-flight-visibility.md): what it is doing, since when as a clock time, that
 * nothing was sent, and the one way out, which is the rep writing the reply. There is no retry
 * here on purpose: a retry that could run twice could produce two of something.
 */
export function InFlightCard({
  view,
  when,
  canWrite,
  onWrite,
}: {
  view: InFlightView;
  when: (at: string) => string;
  /** The reply box exists for this conversation and it is not read-only. */
  canWrite: boolean;
  onWrite: () => void;
}) {
  const card = inFlightCard(view, when);
  const working = view.kind === "working" || view.kind === "redrafting";
  return (
    <article
      className="lcr-sheet lcr-in-flight"
      data-in-flight={view.kind}
      role={view.kind === "failed" ? "alert" : "status"}
    >
      <div className="lcr-step-heading">
        <h3>{card.title}</h3>
        <span className="lcr-badge">{working ? "In progress" : "Needs you"}</span>
      </div>
      <p>{card.body}</p>
      {/* Where the new draft will be, breathing while it is written: the wait is visibly work. */}
      {view.kind === "redrafting" && (
        <div className="lcr-in-flight-lines" aria-hidden="true">
          <span className="lcr-skeleton" data-width="line-1" />
          <span className="lcr-skeleton" data-width="line-2" />
          <span className="lcr-skeleton" data-width="line-3" />
        </div>
      )}
      {canWrite && (
        <div className="lcr-actions">
          <button type="button" className={working ? undefined : "lcr-primary"} onClick={onWrite}>
            {card.action}
          </button>
        </div>
      )}
    </article>
  );
}
